
export const SearchIcon = ({ width = 16, height = 16, stroke = "#9392A2" }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.46208 3.72109C11.0166 5.27563 11.0166 7.79605 9.46208 9.3506C7.90753 10.9051 5.38711 10.9051 3.83257 9.3506C2.27802 7.79605 2.27802 5.27563 3.83257 3.72109C5.38711 2.16654 7.90753 2.16654 9.46208 3.72109Z"
      stroke={stroke}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.43332 9.37354L13.3333 13.3269"
      stroke={stroke}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const ArrowDownIcon = ({ width = 16, height = 16, stroke = "#9392A2" }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 6L8 10L4 6"
      stroke={stroke}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const ArrowUpIcon = ({ width = 16, height = 16, stroke = "#9392A2" }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 10L8 6L4 10"
      stroke={stroke}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);


export const BellIcon = ({ width = 16, height = 16, stroke = "#0F0C18" }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.93332 13.3335H9.06665"
      stroke={stroke}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4.66675 5.68767V5.66634C4.66675 3.82567 6.15942 2.33301 8.00008 2.33301C9.84075 2.33301 11.3334 3.82567 11.3334 5.66634V5.68767V7.33567C11.3334 7.55167 11.4554 7.74834 11.6481 7.84501L11.9834 8.01234C12.4021 8.22234 12.6667 8.65034 12.6667 9.11834C12.6667 9.80101 12.1134 10.3543 11.4307 10.3543H4.56942C3.88675 10.3543 3.33342 9.80101 3.33342 9.11834C3.33342 8.65034 3.59808 8.22234 4.01675 8.01301L4.35208 7.84567C4.54475 7.74834 4.66675 7.55167 4.66675 7.33567V5.68767Z"
      stroke={stroke}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const HomeIcon = ({ width = 24, height = 24, fill = "#0F0C18" }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill={fill}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.11167 10.1367L12.0017 4.5L18.8892 10.1367C19.2758 10.4525 19.5 10.9267 19.5 11.4258V17.8333C19.5 18.7542 18.7542 19.5 17.8333 19.5H6.16667C5.24583 19.5 4.5 18.7542 4.5 17.8333V11.4267C4.5 10.9267 4.72417 10.4525 5.11167 10.1367Z"
    />
  </svg>
);

export const AngleDotIcon = ({ width = 24, height = 24, fill = "#9392A2" }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.3124 5.31527C15.6429 6.64578 15.6429 8.80296 14.3124 10.1335C12.9819 11.464 10.8247 11.464 9.49422 10.1335C8.16371 8.80296 8.16371 6.64578 9.49422 5.31527C10.8247 3.98475 12.9819 3.98475 14.3124 5.31527Z"
      fill={fill}
    />
    <path
      d="M9.59515 13.867C10.9257 15.1975 10.9257 17.3547 9.59515 18.6852C8.26463 20.0157 6.10745 20.0157 4.77694 18.6852C3.44642 17.3547 3.44642 15.1975 4.77694 13.867C6.10745 12.5365 8.26463 12.5365 9.59515 13.867Z"
      fill={fill}
    />
    <path
      d="M19.0019 13.867C20.3324 15.1975 20.3324 17.3547 19.0019 18.6852C17.6714 20.0157 15.5142 20.0157 14.1837 18.6852C12.8532 17.3547 12.8532 15.1975 14.1837 13.867C15.5142 12.5365 17.6714 12.5365 19.0019 13.867Z"
      fill={fill}
    />
  </svg>
);

export const FolderIcon = ({ width = 24, height = 24, fill = "#9392A2" }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M19 6.94H12.529C12.198 6.94 11.888 6.776 11.702 6.502L10.297 4.437C10.111 4.164 9.802 4 9.471 4H5C3.895 4 3 4.895 3 6V18C3 19.105 3.895 20 5 20H19C20.105 20 21 19.105 21 18V8.94C21 7.836 20.105 6.94 19 6.94Z"
      fill={fill}
    />
  </svg>
);

export const SettingIcon = ({ width = 24, height = 24, fill = "#9392A2" }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.9999 8.75006C10.205 8.75006 8.74988 10.2051 8.74988 12.0001C8.74988 13.795 10.205 15.2501 11.9999 15.2501C13.7948 15.2501 15.2499 13.795 15.2499 12.0001C15.2499 10.2051 13.7948 8.75006 11.9999 8.75006Z"
      fill={fill}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.6798 2.80582C12.257 2.57091 11.7428 2.57091 11.32 2.80582L4.12 6.80582C3.67555 7.05274 3.3999 7.5212 3.3999 8.02964V15.9705C3.3999 16.4789 3.67555 16.9474 4.12 17.1943L11.32 21.1943C11.7428 21.4292 12.257 21.4292 12.6798 21.1943L19.8798 17.1943C20.3243 16.9474 20.5999 16.4789 20.5999 15.9705V8.02964C20.5999 7.5212 20.3243 7.05274 19.8798 6.80582L12.6798 2.80582ZM7.24988 12.0001C7.24988 9.37671 9.37653 7.25006 11.9999 7.25006C14.6232 7.25006 16.7499 9.37671 16.7499 12.0001C16.7499 14.6234 14.6232 16.7501 11.9999 16.7501C9.37653 16.7501 7.24988 14.6234 7.24988 12.0001Z"
      fill={fill}
    />
  </svg>
);

export const SupportIcon = ({ width = 24, height = 24, fill = "#9392A2" }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.28547 8.34374C3.11311 8.65832 2.25 9.72836 2.25 11V14C2.25 15.5188 3.48122 16.75 5 16.75H7.5C7.91421 16.75 8.25 16.4142 8.25 16V9C8.25 8.58579 7.91421 8.25 7.5 8.25H5.81483C6.24399 5.78002 8.75862 3.75 12 3.75C15.2414 3.75 17.756 5.78002 18.1852 8.25H16.5C16.0858 8.25 15.75 8.58579 15.75 9V16C15.75 16.4142 16.0858 16.75 16.5 16.75H18.163C17.8244 18.1834 16.5368 19.25 15 19.25H13.8546C13.5579 18.517 12.8393 18 12 18C10.8954 18 10 18.8954 10 20C10 21.1046 10.8954 22 12 22C12.8393 22 13.5579 21.483 13.8546 20.75H15C17.3998 20.75 19.3839 18.9704 19.7047 16.6589C20.882 16.3477 21.75 15.2752 21.75 14V11C21.75 9.72836 20.8869 8.65832 19.7145 8.34375C19.3331 4.83959 15.9262 2.25 12 2.25C8.0738 2.25 4.66693 4.83959 4.28547 8.34374Z"
      fill={fill}
    />
  </svg>
);

export const UploadIcon = ({ width = 16, height = 16, stroke = "#0F0C18" }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.99982 9.88867V1.00004"
      stroke={stroke}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5 4L8 1L11 4"
      stroke={stroke}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M1 7.22217V13.4442C1 14.3037 1.69609 14.9998 2.55552 14.9998H13.4441C14.3036 14.9998 14.9997 14.3037 14.9997 13.4442V7.22217"
      stroke={stroke}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const DoubleArrowLeftIcon = ({ width = 16, height = 16, stroke = "#9392A2" }) => (
  <svg
    width={width}
    className="cursor-pointer"
    height={height}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8 12L4 8L8 4"
      stroke={stroke}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12 12L8 8L12 4"
      stroke={stroke}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const ArrowRightIcon = ({ width = 16, height = 17, stroke = "white", opacity = 0.6 }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 16 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      opacity={opacity}
      d="M13 8.42969H3.66667M13 8.42969L9 4.42969M13 8.42969L9 12.4297"
      stroke={stroke}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const BarChartIcon = ({ width = 24, height = 25, stroke = "#9392A2" }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0)">
      <g clipPath="url(#clip1)">
        <path
          d="M11.8525 6.42969V19.4347"
          stroke={stroke}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M17.7042 7.72998V18.134"
          stroke={stroke}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6 18.134V7.72998"
          stroke={stroke}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0">
        <rect width="24" height="24" fill="white" transform="translate(0 0.429688)" />
      </clipPath>
      <clipPath id="clip1">
        <rect width="24" height="24" fill="white" transform="translate(0 0.429688)" />
      </clipPath>
    </defs>
  </svg>
);

export const VideoIcon = ({
  width = 24,
  height = 25,
  stroke = "#9392A2",
  strokeWidth = "1.5",
  fill = "none"
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 25"
    fill={fill}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.125 18.1797H5.25C4.007 18.1797 3 17.1727 3 15.9297V8.92969C3 7.68669 4.007 6.67969 5.25 6.67969H13.125C14.368 6.67969 15.375 7.68669 15.375 8.92969V15.9297C15.375 17.1727 14.368 18.1797 13.125 18.1797Z"
      stroke={stroke}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15.375 13.5269L19.17 16.5809C19.906 17.1739 21 16.6499 21 15.7049V9.15491C21 8.20991 19.906 7.68591 19.17 8.27891L15.375 11.3329"
      stroke={stroke}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);


export const CircleShapePlusIcon = ({
  width = 24,
  height = 25,
  stroke = "#9392A2",
  strokeWidth = "1.5",
  fill = "none"
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 25"
    fill={fill}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 12.9297C9.239 12.9297 7 10.6917 7 7.92969C7 5.22569 9.3 2.92669 12.004 2.92969C14.764 2.93169 17 5.16969 17 7.92969C17 10.6907 14.762 12.9297 12 12.9297Z"
      stroke={stroke}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12 5.92969V9.92969"
      stroke={stroke}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14 7.92969L10 7.92969"
      stroke={stroke}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7 21.9297C4.239 21.9297 2 19.6917 2 16.9297C2 14.2257 4.3 11.9267 7.004 11.9297C9.764 11.9317 12 14.1697 12 16.9297C12 19.6907 9.762 21.9297 7 21.9297Z"
      stroke={stroke}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M17 21.9297C14.239 21.9297 12 19.6917 12 16.9297C12 14.2257 14.3 11.9267 17.004 11.9297C19.764 11.9317 22 14.1697 22 16.9297C22 19.6907 19.762 21.9297 17 21.9297Z"
      stroke={stroke}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <circle cx="12" cy="13.9297" r="1" fill={stroke} />
  </svg>
);

export const ThreeDotsIcon = ({
  width = 16,
  height = 16,
  fill = "#2C2135",
  onClick = function() {}
}) => (
  <svg
    width={width}
    height={height}
    onClick={() => onClick && onClick()}
    className="cursor-pointer"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle
      cx="1.4"
      cy="1.4"
      r="1.4"
      transform="matrix(-1 0 0 1 15 7)"
      fill={fill}
    />
    <circle
      cx="1.4"
      cy="1.4"
      r="1.4"
      transform="matrix(-1 0 0 1 9.3999 7)"
      fill={fill}
    />
    <circle
      cx="1.4"
      cy="1.4"
      r="1.4"
      transform="matrix(-1 0 0 1 3.7998 7)"
      fill={fill}
    />
  </svg>
);

export const TranslateIcon = ({
  width = 16,
  height = 16,
  fill = "#0F0C18",
  onClick = function() {}
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    onClick={() => onClick && onClick()}
    className="cursor-pointer"
  >
    <g clipPath="url(#clip0)">
      <path d="M5 2.6665V4.6665" stroke={fill} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M13.6667 13.333L11 7.33301L8.33337 13.333" stroke={fill} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M8.92676 12H13.0734" stroke={fill} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M2.33337 9.99984C5.06337 9.78384 7.45071 7.3965 7.66737 4.6665H2.33404" stroke={fill} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M7.66671 9.99984C5.96071 9.86517 4.46804 8.3725 4.33337 6.6665" stroke={fill} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    </g>
    <defs>
      <clipPath id="clip0">
        <rect width="16" height="16" fill="white"/>
      </clipPath>
    </defs>
  </svg>
);

export const ArrowReturnRight = ({
  width = 16,
  height = 16,
  fill = "#9392A2",
  onClick = function() {}
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    onClick={() => onClick && onClick()}
    className="cursor-pointer"
  >
    <path
      d="M13.3333 8.85714L10.1904 5.71429M13.3333 8.85714L10.1904 12M13.3333 8.85714H6.99992C5.34306 8.85714 3.99992 7.514 3.99992 5.85714V1"
      stroke={fill}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const CalendarIcon = ({
  width = 16,
  height = 16,
  fill = "#0F0C18",
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="cursor-pointer"
  >
    <path
      d="M12 13.5151H3.11111C2.49722 13.5151 2 13.0179 2 12.404V4.62625C2 4.01236 2.49722 3.51514 3.11111 3.51514H12C12.6139 3.51514 13.1111 4.01236 13.1111 4.62625V12.404C13.1111 13.0179 12.6139 13.5151 12 13.5151Z"
      stroke={fill}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2 7.29297H13.1111"
      stroke={fill}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.50024 4.76675V2"
      stroke={fill}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.79028 4.76675V2"
      stroke={fill}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const ClipboardIcon = ({
  width = 16,
  height = 16,
  stroke1 = "#2C2135",
  stroke2 = "#0F0C18",
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="cursor-pointer"
  >
    <g clipPath="url(#clip0_11614_5401)">
      <path
        d="M6.71875 4.25H9.5"
        stroke={stroke1}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <rect
        x="3.59375"
        y="2"
        width="8.8125"
        height="12"
        rx="2"
        stroke={stroke2}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_11614_5401">
        <rect width="16" height="16" fill="white"/>
      </clipPath>
    </defs>
  </svg>
);

export const PlusIcon = ({
  width = 16,
  height = 16,
  stroke = "#0F0C18",
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8 4V12"
      stroke={stroke}
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      d="M12 8L4 8"
      stroke={stroke}
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  </svg>
);

export const CirclesThreeIcon = ({
  width = 16,
  height = 16,
  stroke = "#0F0C18",
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.99992 8.33342C9.84059 8.33342 11.3333 6.84142 11.3333 5.00008C11.3333 3.19742 9.79992 1.66475 7.99725 1.66675C6.15725 1.66808 4.66659 3.16008 4.66659 5.00008C4.66659 6.84075 6.15859 8.33342 7.99992 8.33342Z"
      stroke={stroke}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.3333 14.3334C13.174 14.3334 14.6666 12.8414 14.6666 11.0001C14.6666 9.19742 13.1333 7.66475 11.3306 7.66675C9.49063 7.66808 7.99996 9.16008 7.99996 11.0001C7.99996 12.8407 9.49196 14.3334 11.3333 14.3334Z"
      stroke={stroke}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4.66667 14.3334C6.50733 14.3334 8 12.8414 8 11.0001C8 9.19742 6.46667 7.66475 4.664 7.66675C2.824 7.66808 1.33333 9.16008 1.33333 11.0001C1.33333 12.8407 2.82533 14.3334 4.66667 14.3334Z"
      stroke={stroke}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const RightArrowIcon = ({
  width = 16,
  height = 16,
  stroke = "#9392A2",
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6 4L10 8L6 12"
      stroke={stroke}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const CheckCircleIcon = ({
  width = 24,
  height = 24,
  stroke = "#9392A2",
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
  >
    <circle
      cx="12"
      cy="12"
      r="9"
      stroke={stroke}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8 12L11 15L16 10"
      stroke={stroke}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const UserSettingsIcon = ({
  width = 22,
  height = 22,
  stroke = "#9392A2",
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.4693 2.02278C12.833 3.38649 12.833 5.5975 11.4693 6.96121C10.1056 8.32492 7.89455 8.32492 6.53084 6.96121C5.16713 5.5975 5.16713 3.38649 6.53084 2.02278C7.89455 0.659073 10.1056 0.659073 11.4693 2.02278Z"
      stroke={stroke}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.363 11.796C12.064 11.277 10.54 10.991 9 10.991C4.952 10.991 1 12.958 1 15.983V16.983C1 17.535 1.448 17.983 2 17.983H11.413"
      stroke={stroke}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16 21C13.239 21 11 18.762 11 16C11 13.296 13.3 10.997 16.004 11C18.764 11.002 21 13.24 21 16C21 18.761 18.762 21 16 21Z"
      stroke={stroke}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15.9999 17.7419C15.0381 17.7419 14.2581 16.9622 14.2581 16C14.2581 15.058 15.0593 14.2571 16.0013 14.2582C16.9628 14.2589 17.7418 15.0385 17.7418 16C17.7418 16.9619 16.9621 17.7419 15.9999 17.7419Z"
      stroke={stroke}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const TrashIcon = ({
  width = 25,
  height = 24,
  fill = "#9392A2",
  stroke = "#9392A2",
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 25 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.5 7H19.5H5.5Z"
      fill={fill}
    />
    <path
      d="M5.5 7H19.5"
      stroke={stroke}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M18.5 7V18C18.5 19.105 17.605 20 16.5 20H8.5C7.395 20 6.5 19.105 6.5 18V7"
      stroke={stroke}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15.5 3.75H9.5H15.5Z"
      fill={fill}
    />
    <path
      d="M15.5 3.75H9.5"
      stroke={stroke}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.5 11V16"
      stroke={stroke}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.5 11V16"
      stroke={stroke}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const CrossIcon = ({
  width = 24,
  height = 24,
  stroke = "#0F0C18",
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_10534_18052)">
      <path
        d="M17.5 6L5.5 18"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.5 6L17.5 18"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_10534_18052">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const ScheduleCalendarIcon = ({
  width = 25,
  height = 24,
  stroke = "#9392A2",
  fill = "#9392A2",
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 25 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16.5 2V6"
      stroke={stroke}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.5 2V6V2Z"
      fill={fill}
    />
    <path
      d="M8.5 2V6"
      stroke={stroke}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3.5 9H21.5"
      stroke={stroke}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M19.5 4H5.5C4.395 4 3.5 4.895 3.5 6V19C3.5 20.105 4.395 21 5.5 21H19.5C20.605 21 21.5 20.105 21.5 19V6C21.5 4.895 20.605 4 19.5 4Z"
      stroke={stroke}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const EditIcon = ({
  width = 24,
  height = 24,
  stroke = "#9392A2",
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M5.293 15.619L15.619 5.29299C16.009 4.90299 16.642 4.90299 17.032 5.29299L18.708 6.96899C19.098 7.35899 19.098 7.99199 18.708 8.38199L8.381 18.707C8.194 18.895 7.94 19 7.675 19H5V16.325C5 16.06 5.105 15.806 5.293 15.619Z"
      stroke={stroke}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.75 7.16003L16.84 10.25"
      stroke={stroke}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const BigPlusIcon = ({
  width = 19,
  height = 20,
  stroke = "#9392A2",
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 19 20"
    fill="none"
  >
    <path
      d="M9.48535 1.51477V18.4853"
      stroke={stroke}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M1 10H17.9706"
      stroke={stroke}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const WalletIcon = ({
  width = 24,
  height = 24,
  stroke = "#9392A2",
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M3.039 7.91498H19C20.105 7.91498 21 8.80998 21 9.91498V19C21 20.1 20.1 21 19 21H5C3.895 21 3 20.105 3 19V8.29098C3 7.45898 3.515 6.71398 4.294 6.41998L14.647 2.51098C15.301 2.26398 16 2.74698 16 3.44598V7.91398"
      stroke={stroke}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const CalendarThreePartIcon = ({
  width = 16,
  height = 16,
  stroke = "#0F0C18",
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_11616_9981)">
      <g clipPath="url(#clip1_11616_9981)">
        <path
          d="M12 13H3.11111C2.49722 13 2 12.5028 2 11.8889V4.11111C2 3.49722 2.49722 3 3.11111 3H12C12.6139 3 13.1111 3.49722 13.1111 4.11111V11.8889C13.1111 12.5028 12.6139 13 12 13Z"
          stroke={stroke}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M2 5.77771H13.1111"
          stroke={stroke}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5.33301 5.77778L5.88856 3"
          stroke={stroke}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9.22217 5.77778L9.77772 3"
          stroke={stroke}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_11616_9981">
        <rect width="16" height="16" fill="white" />
      </clipPath>
      <clipPath id="clip1_11616_9981">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const BoldPencilIcon = ({
  width = 16,
  height = 16,
  stroke = "#0F0C18",
  onClick = function() {}
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    onClick={() => onClick && onClick()}
    className="cursor-pointer"
    viewBox="0 0 16 16"
    fill="none"
  >
    <path
      d="M3.52865 10.4125L10.4126 3.5285C10.6726 3.2685 11.0946 3.2685 11.3546 3.5285L12.472 4.64583C12.732 4.90583 12.732 5.32783 12.472 5.58783L5.58731 12.4712C5.46265 12.5965 5.29331 12.6665 5.11665 12.6665H3.33331V10.8832C3.33331 10.7065 3.40331 10.5372 3.52865 10.4125Z"
      stroke={stroke}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.16669 4.77344L11.2267 6.83344"
      stroke={stroke}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const StarIcon = ({
  width = 24,
  height = 24,
  stroke = "#9392A2",
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M12 17.235L6.179 20L7.388 13.88L3 9.392L9.179 8.621L12 3L14.821 8.621L21 9.392L16.612 13.88L17.821 20L12 17.235Z"
      stroke={stroke}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const PhoneRingIcon = ({
  width = 24,
  height = 24,
  stroke = "#9392A2",
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
  >
    <g clipPath="url(#clip0_11626_28627)">
      <path
        d="M6.99005 7.99018L4.93005 5.93018"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 5.92V3"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.01 7.99018L19.07 5.93018"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.434 20H20C21.105 20 22 19.105 22 18V16.986C22 15.957 21.472 15 20.598 14.403C18.441 12.932 15.401 12 12 12C8.599 12 5.559 12.932 3.402 14.404C2.528 15.001 2 15.958 2 16.986V18C2 19.105 2.895 20 4 20H5.566C6.394 20 7.066 19.328 7.066 18.5V17.137C7.066 16.83 7.247 16.546 7.533 16.435C8.859 15.921 10.379 15.625 12 15.625C13.621 15.625 15.141 15.921 16.467 16.435C16.753 16.546 16.934 16.83 16.934 17.137V18.5C16.934 19.328 17.606 20 18.434 20Z"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_11626_28627">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const BoldRightArrowIcon = ({
  width = 16,
  height = 16,
  stroke = "#0F0C18",
  onClick = function() {}
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    onClick={() => onClick && onClick()}
    className="cursor-pointer"
    viewBox="0 0 16 16"
    fill="none"
  >
    <path
      d="M12.3333 8L2.99992 8M12.3333 8L8.33325 12M12.3333 8L8.33325 4"
      stroke={stroke}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const SmallCrossIcon = ({
  width = 12,
  height = 12,
  stroke = "#0F0C18",
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 12 12"
    fill="none"
  >
    <path
      d="M3.17139 3.17188L8.82824 8.82873"
      stroke={stroke}
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      d="M3.17139 8.82861L8.82824 3.17176"
      stroke={stroke}
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  </svg>
);

export const SettingsIcon = ({
  width = 16,
  height = 16,
  stroke = "#0F0C18",
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 16 16"
    fill="none"
  >
    <path
      d="M6.3435 2.66675H9.65683C10.0102 2.66675 10.3495 2.80741 10.5995 3.05741L12.9428 5.40075C13.1928 5.65075 13.3335 5.98942 13.3335 6.34342V9.65741C13.3335 10.0107 13.1928 10.3501 12.9428 10.6001L10.5995 12.9434C10.3495 13.1927 10.0108 13.3334 9.65683 13.3334H6.34283C5.9895 13.3334 5.65016 13.1927 5.40016 12.9427L3.05683 10.5994C2.8075 10.3494 2.66683 10.0107 2.66683 9.65675V6.34342C2.66683 5.99008 2.8075 5.65075 3.0575 5.40075L5.40083 3.05741C5.65083 2.80741 5.9895 2.66675 6.3435 2.66675Z"
      stroke={stroke}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.11422 6.1143C5.07282 7.1557 5.07282 8.84414 6.11422 9.88554C7.15562 10.9269 8.84406 10.9269 9.88545 9.88554C10.9269 8.84414 10.9269 7.1557 9.88545 6.1143C8.84405 5.0729 7.15561 5.0729 6.11422 6.1143Z"
      stroke={stroke}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);





























